import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import Layout from '@/components/Layout';
import RequireAuth from '@/components/RequireAuth';
import { AuthProvider } from '@/contexts/AuthContext';

import Home from '@/pages/Home';
import AccessMats from '@/pages/AccessMats';
import RigMats from '@/pages/RigMats';
import CraneMats from '@/pages/CraneMats';
import InfrastructureProjects from '@/pages/InfrastructureProjects';
import IndigenousPartnerships from '@/pages/IndigenousPartnerships';
import AllProjects from '@/pages/AllProjects';
import OilGasPipeline from '@/pages/OilGasPipeline';
import Renewables from '@/pages/Renewables';
import Procurement from '@/pages/Procurement';
import Sustainability from '@/pages/Sustainability';
import MattingSuppliers from '@/pages/MattingSuppliers';
import About from '@/pages/About';
import Contact from '@/pages/Contact';
import Quote from '@/pages/Quote';
import Login from '@/pages/Login';
import Admin from '@/pages/Admin';
import ChangePassword from '@/pages/ChangePassword';
import NotFound from '@/pages/NotFound';

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Routes>
                        <Route element={<Layout />}>
                            <Route path="/" element={<Home />} />
                            <Route path="/access-mats" element={<AccessMats />} />
                            <Route path="/rig-mats" element={<RigMats />} />
                            <Route path="/crane-mats" element={<CraneMats />} />
                            <Route path="/catalog" element={<MattingSuppliers />} />

                            {/* Projects */}
                            <Route path="/projects" element={<AllProjects />} />
                            <Route path="/projects/infrastructure" element={<InfrastructureProjects />} />
                            <Route path="/projects/oil-gas-pipeline" element={<OilGasPipeline />} />
                            <Route path="/projects/renewables" element={<Renewables />} />

                            {/* Partnerships */}
                            <Route
                                path="/partnerships"
                                element={<Navigate to="/partnerships/indigenous" replace />}
                            />
                            <Route path="/partnerships/indigenous" element={<IndigenousPartnerships />} />
                            <Route path="/partnerships/procurement" element={<Procurement />} />
                            <Route path="/partnerships/sustainability" element={<Sustainability />} />

                            {/* SPA-level safety-net redirects (server-side 301 also configured
                                in backend/server.py + frontend/public/_redirects). */}
                            <Route
                                path="/infrastructure-projects"
                                element={<Navigate to="/projects/infrastructure" replace />}
                            />
                            <Route
                                path="/indigenous-partnerships"
                                element={<Navigate to="/partnerships/indigenous" replace />}
                            />
                            <Route
                                path="/all-products"
                                element={<Navigate to="/catalog" replace />}
                            />
                            <Route
                                path="/matting-suppliers"
                                element={<Navigate to="/catalog" replace />}
                            />

                            <Route path="/about" element={<About />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/quote" element={<Quote />} />
                            <Route path="/login" element={<Login />} />
                            {/* /dashboard removed - client lease portal retired. The
                                NotFound catch-all below renders the on-brand 404 page
                                for any legacy inbound links. Backend admin lease
                                CRUD remains intact at /api/admin/leases/*. */}
                            <Route
                                path="/admin"
                                element={
                                    <RequireAuth role="admin">
                                        <Admin />
                                    </RequireAuth>
                                }
                            />
                            <Route
                                path="/admin/change-password"
                                element={
                                    <RequireAuth role="admin" allowForcedRotation>
                                        <ChangePassword />
                                    </RequireAuth>
                                }
                            />
                            <Route path="*" element={<NotFound />} />
                        </Route>
                    </Routes>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
